/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.5"
        height="81.78"
        viewBox="0 0 85.5 81.78"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M42.78 0A40.69 40.69 0 0 1 83.5 40.69a1.25 1.25 0 0 1-2.5 0A38.2 38.2 0 0 0 5.36 33a1.25 1.25 0 0 1-2.32.34l-.06-.12-2.89-7a1.25 1.25 0 0 1 2.26-1.07l.06.11 1.44 3.51v-.15A40.73 40.73 0 0 1 42.2 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M9.58 27.69a1.25 1.25 0 0 1 1.45 2l-.11.08-6.25 3.94a1.25 1.25 0 0 1-1.44-2l.11-.08ZM2.78 39.83a1.25 1.25 0 0 1 1.25 1.25 38.2 38.2 0 0 0 75.61 7.7 1.25 1.25 0 0 1 2.28-.42l.06.11 3.39 6.72a1.25 1.25 0 0 1-2.17 1.24l-.07-.12-1.87-3.71A40.7 40.7 0 0 1 42.8 81.77h-.58A40.7 40.7 0 0 1 1.5 41.08a1.25 1.25 0 0 1 1.28-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M80.33 48.03a1.25 1.25 0 0 1 1.44 2l-.11.08-6.24 3.94a1.25 1.25 0 0 1-1.45-2l.11-.08Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M39.44 12.58v4.92l-.76.14-.77.15A11.79 11.79 0 0 0 29.03 25a14.66 14.66 0 0 0-1 6.71 11.51 11.51 0 0 0 6.15 9.79 47.8 47.8 0 0 0 5.16 2.32c2.16.91 4.36 1.74 6.51 2.66a3.93 3.93 0 0 1 2.46 4.29c-.16 2.12-1.15 3.79-3.45 4.3a12.55 12.55 0 0 1-2.73.3 6.78 6.78 0 0 1-6.93-5.06c-.2-.61-.34-1.23-.53-1.89l-8.24 2.12a17.11 17.11 0 0 0 4 8.16 13.86 13.86 0 0 0 9 4.16v6.37h5.33v-6.29c1.07-.22 2.11-.38 3.12-.64a12.26 12.26 0 0 0 8.67-7 14.34 14.34 0 0 0 1-8.59 11.35 11.35 0 0 0-5.74-8.21 63.4 63.4 0 0 0-7.89-3.44c-1.61-.64-3.19-1.39-4.75-2.15a3.47 3.47 0 0 1-1.77-2.15 4.81 4.81 0 0 1 3.37-6.06 5.6 5.6 0 0 1 5.51 1.44 10.54 10.54 0 0 1 2.22 3.36c.18.4.35.81.53 1.25l7.38-3a14.81 14.81 0 0 0-2.71-5.56 13 13 0 0 0-9-4.66v-4.95Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'DollarSignRevolvingArrowsIcon';

export default Icon;
